import React from 'react';
import { useHistory } from 'react-router-dom';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonCardContent, IonIcon } from '@ionic/react';
import {
  chevronForwardOutline,
  navigateCircleOutline,
  notificationsOutline,
  sparklesOutline,
  settingsOutline,
  shieldCheckmarkOutline,
} from 'ionicons/icons';
import { useAuth } from '../../application/use-cases/auth/AuthContext';
import './Settings.css';

// "Más" de la barra del celular: lo que no entra en las cuatro pestañas
// principales. En escritorio todo esto está en la barra lateral.
const More: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const items = [
    { icon: navigateCircleOutline, label: 'Mapa del campo', href: '/app/map' },
    { icon: notificationsOutline, label: 'Alertas', href: '/app/alerts' },
    { icon: sparklesOutline, label: 'Asistente Domiot', href: '/app/ai' },
    { icon: settingsOutline, label: 'Ajustes', href: '/app/settings' },
    ...(user?.isAdmin ? [{ icon: shieldCheckmarkOutline, label: 'Admin', href: '/app/admin' }] : []),
  ];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Más</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div className="profile-card">
          <span className="profile-avatar">{(user?.name ?? '?').trim().charAt(0).toUpperCase()}</span>
          <span>
            <strong>{user?.name}</strong>
            <small>{user?.email}</small>
          </span>
        </div>
        <IonCard>
          <IonCardContent className="more-list">
            {items.map((item) => (
              <button key={item.href} className="settings-link-row" onClick={() => history.push(item.href)}>
                <IonIcon icon={item.icon} />
                {item.label}
                <IonIcon icon={chevronForwardOutline} className="chevron" />
              </button>
            ))}
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default More;
